import { render } from "./BasePrice.vue?vue&type=template&id=68165f4c&scoped=true"
import script from "./BasePrice.js?vue&type=script&lang=js"
export * from "./BasePrice.js?vue&type=script&lang=js"

import "./style.css?vue&type=style&index=0&id=68165f4c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68165f4c"]])

export default __exports__